import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=11967750&scoped=true"
import script from "./editInfo.vue?vue&type=script&lang=js"
export * from "./editInfo.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./editInfo.vue?vue&type=style&index=1&id=11967750&prod&lang=scss&scoped=true"
import style2 from "./editInfo.vue?vue&type=style&index=2&id=11967750&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11967750",
  null
  
)

export default component.exports